var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRheinbahnLogoImageOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 55,
    viewBox: "0 0 802 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ArtBoard1",
    transform: "matrix(1.00185,0,0,1.02644,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 799.823,
    height: 150.033,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 799.823,
    height: 150.033
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998156,0,0,0.97424,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.6,383.5C250.9,383.5 234.1,400.3 234.1,421C234.1,441.7 250.9,458.5 271.6,458.5C292.3,458.5 309.1,441.7 309.1,421C309.1,400.3 292.2,383.5 271.6,383.5ZM271.6,443.3C259.3,443.3 249.3,433.3 249.3,421C249.3,408.7 259.3,398.7 271.6,398.7C283.9,398.7 293.9,408.7 293.9,421C293.9,433.2 283.9,443.3 271.6,443.3Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.6,344C229.1,344 194.6,378.5 194.6,421C194.6,463.5 229.1,498 271.6,498C312.5,498 346.1,465.9 348.4,425.6L378.4,425.6L381,410.3L332,410.3C332.6,413.8 332.9,417.4 332.9,421C332.9,454.8 305.4,482.3 271.6,482.3C237.8,482.3 210.3,454.8 210.3,421C210.3,387.2 237.8,359.7 271.6,359.7C285.3,359.7 298,364.2 308.2,371.9L387.6,371.9L390.2,356.6L313.6,356.6C301.5,348.6 287.1,344 271.6,344Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.7,398.6L383,398.6L385.6,383.3L320,383.3C323.6,388 326.6,393.1 328.7,398.6Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRheinbahnLogoImageOnly);
export default __webpack_public_path__ + "static/media/rheinbahn-logo-image-only.a7e7f9bd577a8acb595afac3e6236a10.svg";
export { ForwardRef as ReactComponent };